import(/* webpackMode: "eager" */ "/app/packages/apps/front/src/app/global-error.tsx");
